export enum Theme {
  AUTO = 'auto',
  LIGHT = 'light',
  DARK = 'dark',
  HIGH_CONTRAST = 'high_contrast',
}
